// Minimal CSV builder — no external dependency, since papaparse isn't
// confirmed to be in this project. Escapes quotes/commas/newlines per RFC 4180.
const escapeCsvValue = (value) => {
  const str = String(value ?? "")
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export const buildCsv = (headers, rows) => {
  const headerLine = headers.map(escapeCsvValue).join(",")
  const lines = rows.map((row) => row.map(escapeCsvValue).join(","))
  return [headerLine, ...lines].join("\r\n")
}

export const downloadCsv = (filename, csvContent) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

// Standard audit/compliance export — one row per issued credential.
// Learner email is deliberately not included: certificate docs only store
// issuedTo (a name) and userId, not email, and joining against learner
// profiles for every row would add a read-per-learner this export doesn't
// currently make. Add it later if an auditor specifically needs it.
export const exportCredentialsCsv = (certificates, orgName) => {
  const headers = [
    "Credential ID",
    "Learner Name",
    "Learner User ID",
    "Course",
    "Score (%)",
    "Status",
    "Issue Date",
    "Revoked Date",
    "Issued By",
    "Template",
  ]

  const rows = certificates.map((c) => [
    c?.certId || "",
    c?.issuedTo || "",
    c?.userId || "",
    c?.courseTitle || "",
    c?.score ?? "",
    c?.status === "revoked" ? "Revoked" : "Valid",
    c?.issueDate?.slice(0, 10) || "",
    c?.revokedAt?.toDate ? c.revokedAt.toDate().toISOString().slice(0, 10) : "",
    c?.issuedBy || orgName || "",
    c?.templateSnapshot?.name || "Default",
  ])

  const csv = buildCsv(headers, rows)
  const dateStamp = new Date().toISOString().slice(0, 10)
  const safeOrgName = (orgName || "organization").replace(/[^a-z0-9]/gi, "-").toLowerCase()
  downloadCsv(`${safeOrgName}-credentials-audit-${dateStamp}.csv`, csv)
}